import * as i18n from "../../i18n.ts";
import * as FwDatas from "../../FwDatas.ts";
import ApiServer from "../../ApiServer.ts";
import {SyncCache,BaseCache} from "../../lib/SyncCache.ts";
import { GeocodedAddress, ILocation, IPlace } from "../fizapilib.auto.ts";

import Icons, {type SvgFile} from "../../svg/Icons.ts";

// Augmentation of the generated beans with the properties and methods added dynamically below
declare module "../fizapilib.auto.ts" {
  interface IPlace {
    /** alias of placeId */
    id?: string;
    icon?: SvgFile;
  }
  interface GeocodedAddress {
    latitude?: number;
    longitude?: number;
    simpleFormat(): string;
  }
  interface ILocation {
    isError?: boolean;
    canRequestAutotrack?: boolean;
    canRequestLocation?: boolean;
    cannotRequestAnything?: boolean;
    warnText?: string;
    shareText?: string;
    place?: IPlace;
    panicButtonActivated?: boolean;
  }
}

export {PlaceCache,PositionCache};
const PlaceCache = new SyncCache<IPlace>(ApiServer.poisync,function(a,b){return a.name.localeCompare(b.name);});

const PositionCache = new BaseCache(ApiServer.locgetpositions2.prepare(function(decoded){
    var result = {},i;
    for (i = 0; i < decoded.length; i++){
      result[decoded[i].accountId] = decoded[i];
    }
    return result;
  }))
/**
 * place and location
 */

Object.assign(IPlace.prototype,{
  onDecode(this: IPlace): void {
    //TODO check that this "id" is used
    this.id = this.placeId;
    this.placeType = this.placeType || 'UNKNOWN';
    this.icon = (()=>{
      switch (this.placeType){

        case "BANK":return Icons.places.fw_place_mini_bank;
        case "DOCTOR":return Icons.places.fw_place_mini_doctor;
        case "HOME":return Icons.places.fw_place_mini_home;
        case "HOSPITAL":return Icons.places.fw_place_mini_hospital;
        case "MARKET":return Icons.places.fw_place_mini_market;
        case "MUSIC":return Icons.places.fw_place_mini_music;
        case "PARK":return Icons.places.fw_place_mini_park;
        case "POLICE":return Icons.places.fw_place_mini_police;
        case "RESTAURANT":return Icons.places.fw_place_mini_restaurant;
        case "SCHOOL":return Icons.places.fw_place_mini_school;
        case "SHOPPING":return Icons.places.fw_place_mini_shopping;
        case "SPORT":return Icons.places.fw_place_mini_sport;
        case "TRAVEL":return Icons.places.fw_place_mini_travel;
        case "UNIVERSITY":return Icons.places.fw_place_mini_university;
        case "UNKNOWN":return Icons.places.fw_place_mini_unknown;
        case "WORK":return Icons.places.fw_place_mini_work;
        default:return Icons.places.fw_place_mini_default;

      }
    })();
  }
});

Object.assign(GeocodedAddress.prototype,{
  simpleFormat:function(this: GeocodedAddress): string {
    var res: string[] = [];
    if(this.attribute4Line){
      res.push(this.attribute4Line);
    }
    if(this.attribute2Town){
      res.push(this.attribute2Town);
    }
    if(res.length===0){
      if(this.attribute1State){
        res.push(this.attribute1State);
      }
      if(this.attribute0Country){
        res.push(this.attribute0Country);
      }
    }
    return res.join(', ');
  },
  onDecode(this: GeocodedAddress): void {
    this.latitude = this.latitudeE6/1000000;
    this.longitude = this.longitudeE6/1000000;
  }
});

Object.assign(ILocation.prototype,{
  onDecode(this: ILocation): void {
    this.isError = this.locationState==='CANNOT_CONNECT';
    if(this.locationState!=='LOCATION_NOT_AUTHORIZED'){
      this.canRequestAutotrack = (this.geolocSharing!=="ALWAYS");
      this.canRequestLocation = (this.geolocSharing==="ALWAYS");
    }
    this.cannotRequestAnything = !this.canRequestLocation && !this.canRequestAutotrack;
    if(this.geolocSharing!=="ALWAYS"){
      this.warnText = i18n.get('map.locationDisabled');
    }else{
      if(this.locationState==="DEVICELOCATION_TURNED_OFF"){
        this.warnText = i18n.get('map.devicelocationDisabled');
      }else if(this.geolocSharingEndDate){
        this.shareText =  i18n.get('map.locationSharedTemp');
      }

    }

    this.place = FwDatas.get(this.placeId);
    try{
      this.panicButtonActivated = this.author().panicButtonActivated;
    }catch(e){
    }
  }
});
